import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/app';
import { AppContextProvider } from './app/app.context';
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
  <React.StrictMode>
    <AppContextProvider>
      <App />
    </AppContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);